import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/',
});

// Add a request interceptor to include the token in all requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// New functions for granular availability control
export const addSingleSlot = (slotData) => {
    return api.post('/api/availability/slots', slotData);
};

export const deleteAvailabilitySlot = (slotId) => {
    return api.delete(`/api/availability/slots/${slotId}`);
};

export const removeAvailabilityForDate = (date) => {
    return api.delete(`/api/availability/slots?date_to_clear=${date}`);
};

export const moveBooking = (bookingId, newSlotId) => {
    return api.put(`/api/bookings/${bookingId}/move`, { new_slot_id: newSlotId });
};



export default api;
